import { Sparkle } from "lucide-react";

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-ocean/10 bg-sand py-4" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center">
      {[...items, ...items, ...items, ...items].map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-6 pr-6 font-display text-sm font-medium uppercase tracking-[0.3em] text-ocean/60"
        >
          {item}
          <Sparkle className="h-3 w-3 text-coral" fill="currentColor" />
        </span>
      ))}
    </div>
  </div>
);
